'use client';

import { useCallback } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { notify } from 'src/utils/notifications';
import { useGetTxParams } from '../transactions/useGetTxParams';

interface CancelInsuranceFundUnstakeOptions {
	marketIndex: number;
}

export const useCancelInsuranceFundUnstake = () => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const getTxParams = useGetTxParams();

	const cancelInsuranceFundUnstakeRequest = useCallback(
		async (opts: CancelInsuranceFundUnstakeOptions): Promise<boolean> => {
			if (!driftClient) return false;

			const toastId = `cancel-unstake-from-if-${opts.marketIndex}`;

			notify({
				id: toastId,
				type: 'awaiting_wallet_confirmation',
				showUntilCancelled: true,
			});

			try {
				const _txid = await driftClient.cancelRequestRemoveInsuranceFundStake(
					opts.marketIndex,
					getTxParams()
				);

				notify({
					id: toastId,
					type: 'success',
					message: 'Canceled unstake request.',
					showUntilCancelled: false,
				});

				return true;
			} catch (err: any) {
				console.log(err);
				notify({
					id: toastId,
					type: 'error',
					message: 'Failed to cancel unstake request.',
					description: `${err}`,
					showUntilCancelled: false,
				});
				return false;
			}
		},
		[driftClient, getTxParams]
	);

	return { cancelInsuranceFundUnstakeRequest };
};
